export const printPageStyles = {
  container: {
    position: 'fixed',
    height: '100%',
    width: '100%',
    opacity: '0',
    color: '#000',
    '@media print': {
      position: 'static',
      opacity: '1'
    }
  },
  page: {
    tableLayout: 'fixed',
    height: '100vh',
    fontSize: '15px',
    fontWeight: 'bold',
    borderCollapse: 'collapse',
    background: '#fff',
    width: '100%',
    '& td': {
      height: '25%'
    }
  },
  item: {
    padding: '1.18em 2em 2em',
    border: '1px solid #000'
  },
  label: {
    fontSize: '.8em',
    fontWeight: 'normal'
  },
  nameField: {
    padding: '0 0 .4em',
    margin: '0 0 .8em',
    '& $label': {
      display: 'block'
    }
  },
  name: {
    fontSize: '2em'
  },
  passcode: {
    margin: '.5em 0 0',
    display: 'flex',
    '& > *': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '1.6em',
      height: '2.4em',
      width: '2.4em',
      borderRadius: '.4em',
      border: '1px solid #000',
      marginRight: '.6em'
    }
  },
  fullName: {
    fontSize: '.8em',
    lineHeight: '1.4',
    borderBottom: '1px solid #000',
    marginBottom: '3em',
    display: 'inline-block'
  }
}

export const printPasscodesStyles = ({ FONT_SIZES, COLORS }) => ({
  content: {
    minWidth: '460px',
    maxWidth: '460px',
    padding: '0',
    '@media (max-width: 575px)': {
      minWidth: 'auto'
    }
  },
  img: {
    borderRadius: '6px 6px 0 0',
    overflow: 'hidden',
    padding: '0 0 54.5%',
    position: 'relative',
    '& img': {
      position: 'absolute',
      left: '0',
      top: '0',
      width: '100%'
    }
  },
  desc: {
    height: '200px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '& h2': {
      ...FONT_SIZES.HEADING_LARGE.STYLE,
      margin: '0 0 10px',
      color: '#000'
    },
    '& p': {
      margin: '0'
    }
  },
  button: {
    margin: '20px auto 0',
    paddingLeft: '20px',
    paddingRight: '20px'
  },
  closeButton: {
    fontSize: '17px',
    right: '20px',
    top: '20px',
    color: '#fff',
    position: 'absolute',
    zIndex: '100'
  }
})
